module.exports = __webpack_public_path__ + "static/media/React-icon.svg.de303a4b.png";